/**
 * What the workspace switch says (lifted verbatim out of src/components/WorkspaceTransitionOverlay.tsx, PV5-8:D part 1,
 * 2026-10-13). Today's overlay and the new design's both draw these, so the two cannot say different things.
 *
 * The boot splash's continuation (public/index.html) writes two of them before any script of the app has loaded, as
 * literals: `arriving` and `unnamedOrganization`. tests/workspaces/workspaceSwitchWords.test.ts holds those literals
 * equal to these.
 */
export const SWITCH_WORDS = {
  /** A live switch, while the destination is being made ready. */
  switching: 'changing organization',
  /** The continuation after the reload, until the destination resolves. */
  arriving: 'entering organization',
  failedTitle: "couldn't switch",
  failedLine: "the organization change didn't go through — you're right where you were.",
  /** The organization's name when the switch was not told it: never a raw account id. */
  unnamedOrganization: 'your other organization',
} as const;

/** The organization named on the overlay. */
export const organizationShown = (label: string | null): string => label || SWITCH_WORDS.unnamedOrganization;

/** The line under the name when the switch opens a thread. */
export const openingThread = (threadTitle: string): string => `opening “${threadTitle}”`;

/** The line that says whose usage the work now counts toward. */
export const usageBelongsTo = (organization: string): string => `work and usage here belong to ${organization}`;
